import * as React from 'react';
import withStyles from 'react-jss'
import cn from 'classnames';
import {black3, white1, red5} from '@riiid/santa-closet-web';

const styles = {
  section: {
    width: '100%',
    padding: 30,
    margin:{
      bottom: 20
    },
    background: white1,
    '& h2': {
      padding: '10px 0',
      margin:{
        bottom: 20
      },
      color: red5,
      fontWeight: 'bold',
      fontSize: 20,
      textAlign: 'left',
      borderBottom: `1px solid ${black3}`
    },
    '& h3': {
      textAlign: 'left'
    }
  }
};

const StyledSection = ({classes, title, children, col}) => {
  return (
    <div className={cn(classes.section, col? col : '')}>
      <h2>{title}</h2>
      {children}
    </div>
  )
};
const Section = withStyles(styles)(StyledSection);

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js